<template>
    <div class="d-flex align-items-center rounded-sm p-2" :style="{ backgroundColor: bgColor }">
        <img alt="" src="/img/info-icon.svg" class="infoIcon img-responsive mr-3">
        <span class="text-secondary font-xs info-text font-weight-medium"><slot></slot></span> 
    </div>
</template>
<script>
export default {
  props: {
    bgColor: {
      type: String,
      default: '#F8F8F8'
    }
  }
}
</script>
<style scoped>
    .infoIcon {
        height:auto;
        width: 1.5rem;
    }

    .info-text{
        color: #00000099 !important;
    }
</style>